import { TermsOfUse } from '@/components/screens/landing/terms-of-use/termsOfUse';
import { GetStaticProps, NextPage } from 'next';

const TermsOfUsePage: NextPage = () => {
	return <TermsOfUse />;
};

export const getStaticProps: GetStaticProps = async () => {
	return { props: {} };
};

export default TermsOfUsePage;
